if (!customElements.get('product-card')) {
  class ProductCard extends Product {
    constructor() {
      super();

      this.bindEvents();
    }

    updateMediaUnsubscribed = undefined;

    connectedCallback() {
      this.updateMediaUnsubscribed = subscribeEvent(
        PUB_SUB_EVENTS.filterSwatch,
        ({ source, data }) => {
          this.updateMedia(data.swatchList);
        }
      );
      this.checkColorCollection();
      this.checkSizeCollection();
      
      // Update media based on checked inputs when page loads
      setTimeout(() => {
        this.updateMediaFromCheckedInput();
      }, 100);
    }

    disconnectedCallback() {
      if (this.updateMediaUnsubscribed) this.updateMediaUnsubscribed?.();
    }

    checkSizeCollection() {
      if (!window.isCollection || !window.isSizeCollection) return;
      const variantButtons = this.querySelectorAll('input.js-product-option');
      if (variantButtons.length == 0) return;
      variantButtons.forEach((button) => {
        if (window.isSizeCollection.indexOf(button.value) > -1) {
          button.click();
        }
      });
    }

    checkColorCollection() {
      if (!window.isCollection || !window.isColorCollection) return;
      const variantButtons = this.querySelectorAll('input.js-product-option-swatch');
      if (variantButtons.length == 0) return;
      
      variantButtons.forEach((button) => {
        if (window.isColorCollection.indexOf(button.value) > -1) {
          button.click();
        }
      });
      
      // Update the media after color selection
      setTimeout(() => {
        this.updateMediaFromCheckedInput();
      }, 150);
    }

    bindEvents() {
      this.initProductData();
      this.initForm();
      this.handleQtyInput();
      this.scrollVariants();
      this.getCollectionFilterData();

      this.addEventListener('change', (event) => {
        this.onVariantChange(event);
        this.updateUrl();
        this.updateProductInventoryStatus();
        this.updateMediaFromCheckedInput();
      });
    }

    initProductData() {
      this.updateOptions();
      this.getVariantData();
      this.updateMasterId();
    }

    string_to_slug(str) {
      str = str.replace(/^\s+|\s+$/g, ''); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      var from = 'àáãäâèéëêìíïîòóöôùúüûñç·/_,:;';
      var to = 'aaaaaeeeeiiiioooouuuunc------';

      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }

      str = str
        .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

      return str;
    }

    
    // Update media based on checked input
    updateMediaFromCheckedInput() {
      if (this.currentVariant) {
        const imageSlides = this.querySelectorAll('.js-product-media');
        let selectedMedia = 0;

        imageSlides.forEach((imageSlide, imageIndex) => {
          const imageVariants = imageSlide.dataset.variants;
          if (imageVariants && imageVariants.includes(this.currentVariant.id)) {
            selectedMedia = imageIndex;
          }
        });

        const carousel = this.querySelector('swiper-carousel');
        carousel?.scrollTo(selectedMedia);
        return;
      }

      const checkedInputs = this.querySelectorAll('input.js-product-option:checked, input.js-product-option-swatch:checked');
      if (checkedInputs.length === 0) return;

      const checkedValues = Array.from(checkedInputs).map(input => input.value.toLowerCase());
      this.updateMediaByValues(checkedValues);
    }

    // Update media based on specific values
    updateMediaByValues(values) {
      const imageSlides = this.querySelectorAll('.js-product-media');
      let selectedMedia = 0;

      imageSlides.forEach((imageSlide, imageIndex) => {
        const imageOptions = imageSlide.dataset.options;
        const imageOptionsHandle = imageSlide.dataset.optionsHandle;

        if (imageOptions) {
          const imageOptionsLower = imageOptions.toLowerCase();
          const hasFullMatch = values.every(value =>
            imageOptionsLower.includes(value) || imageOptions.includes(value)
          );

          if (hasFullMatch) {
            selectedMedia = imageIndex;
          }
        }

        if (this.collectionFilterData && imageOptionsHandle) {
          this.collectionFilterData.forEach((optionGroup) => {
            const optionName = optionGroup.optionName.toLowerCase();
            const groupedValues = optionGroup.groupedValues.split(',');

            values.forEach(checkedValue => {
              if (optionName === checkedValue) {
                const hasFullMatch = groupedValues.every((optionValue) =>
                  imageOptionsHandle.includes(optionValue)
                );
                if (hasFullMatch) selectedMedia = imageIndex;
              }
            });
          });
        }
      });

      const carousel = this.querySelector('swiper-carousel');
      carousel?.scrollTo(selectedMedia);
    }

    updateMedia(swatchList) {
      const imageSlides = this.querySelectorAll('.js-product-media');
      let selectedMedia = 0;

      imageSlides.forEach((imageSlide, imageIndex) => {
        if (this.currentVariant) {
          const imageVariants = imageSlide.dataset.variants;
          if (imageVariants && imageVariants.includes(this.currentVariant.id)) {
            selectedMedia = imageIndex;
          }
          return;
        }

        if (swatchList) {
          swatchList.forEach((swatchName) => {
            const imageOptions = imageSlide.dataset.options || '';
            if (
              imageOptions.includes(swatchName) ||
              imageOptions.toLowerCase().includes(swatchName.toLowerCase())
            ) {
              selectedMedia = imageIndex;
            }
          });
        }
      });

      const carousel = this.querySelector('swiper-carousel');
      carousel?.scrollTo(selectedMedia);
    }

    updateUrl() {
      const productUrls = this.querySelectorAll('.js-product-url');
      if (!this.currentVariant || !productUrls) return;

      productUrls.forEach((productUrl) => {
        productUrl.href = `${productUrl.dataset.url}?variant=${this.currentVariant?.id}`;
      });
    }

    getCollectionFilterData() {
      const collectionFiltersJson = document.getElementById('CollectionFilterJson');

      if (collectionFiltersJson)
        this.collectionFilterData = JSON.parse(collectionFiltersJson.textContent);
    }

    /* Update product inventory status */
    updateProductInventoryStatus() {
      this.inventoryStatus = this.inventoryStatus || this.querySelector('.js-product-inventory');

      if (!this.currentVariant) return;

      let inventoryStatus = 'in-stock';
      const { inventory_management, inventory_policy, quantity } = this.currentVariant;

      if (inventory_management == 'shopify') {
        if (quantity > 0) inventoryStatus = 'in-stock';
        else if (inventory_policy == 'continue') inventoryStatus = 'continue';
        else inventoryStatus = 'out-stock';
      }

      this.inventoryStatus.dataset.status = inventoryStatus;
    }

    /** Prevent parent carousel scroll when scroll variants scrollbar */
    scrollVariants() {
      const variantOptionRows = this.querySelectorAll('.js-variant-scrollbar');
      if (!variantOptionRows) return;

      variantOptionRows.forEach((row) => {
        let isDown = false,
          startX,
          scrollLeft,
          featureCollectionCarousel = this.closest('swiper-carousel');

        row.addEventListener('mouseover', (e) => {
          if (featureCollectionCarousel) featureCollectionCarousel.toggleTouchMove(false);
        });

        row.addEventListener('mousedown', (e) => {
          isDown = true;
          startX = e.pageX - row.offsetLeft;
          scrollLeft = row.scrollLeft;
          if (featureCollectionCarousel) featureCollectionCarousel.toggleTouchMove(false);
        });

        row.addEventListener('mouseleave', () => {
          isDown = false;
          if (featureCollectionCarousel) featureCollectionCarousel.toggleTouchMove(true);
        });

        row.addEventListener('mouseup', () => {
          isDown = false;
        });

        row.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - row.offsetLeft;
          const walk = (x - startX) * 0.88;
          row.scrollLeft = scrollLeft - walk;
        });
      });
    }
  }

  customElements.define('product-card', ProductCard);
}